<template>
  <base-indicator
    :text="confidenceFormat"
    :class="classForMatchConfidence"
  />
</template>

<script>
import BaseIndicator from './BaseIndicator'

export default {
  name: 'OwalIndicatorConfidence',
  components: {
    BaseIndicator,
  },
  props: {
    confidence: {
      type: Number,
      required: true,
    },
    confidenceThreshold: {
      type: Number,
      default: 0.98,
    },
    confidenceLevel: {
      type: Number,
    },
    automaticColor: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    /**
     * @return A CSS class appropriate for the confidence rating.
     */
    classForMatchConfidence () {
      const conf = this.confidence
      let cssClass = ''

      if (!this.automaticColor) {
        return cssClass
      }

      if (this.confidenceLevel !== null && this.confidenceLevel !== undefined) {
        if (this.confidenceLevel === 0) {
          return 'cirlce red'
        } else if (this.confidenceLevel === 1) {
          return 'cirlce yellow'
        } else if (this.confidenceLevel === 2) {
          return 'cirlce green'
        } else {
          console.log(`typeof confidenceLevel=${typeof this.confidenceLevel} confidenceLevel=${this.confidenceLevel}`)
          return 'cirlce orange'
        }
      }

      const threshold = this.confidenceThreshold || 0.98
      if (conf < threshold) {
        return 'circle red'
      } else {
        return 'circle green'
      }
    },
    /**
     * @return The confidence string, formatted to fit in the circle.
     */
    confidenceFormat () {
      const conf = this.confidence
      const confidenceFixed = `${parseFloat(conf).toFixed(2)}`

      if (confidenceFixed.charAt(0) === '1') {
        return '1'
      }

      return confidenceFixed.replace(/^0+/, '')
    },
    /**
     * A legacy method, preserved here.
     */
    diffFormat () {
      const diff = this.match.diff
      if (!diff) return ''
      return diff.toFixed(2)
    },
  },
}
</script>

<style scoped>
  /* --- Circle Colors --- */
  .red {
    color: #c0ccda;
    background: rgba(208, 2, 27, 1);
  }

  .yellow {
    color: #475669;
    background: rgba(255, 243, 108, 1);
  }

  .green {
    color: #475669;
    background: rgba(171, 213, 124, 1);
  }

  .orange {
    color: #c0ccda;
    background: rgb(208, 119, 2);
  }
</style>
